/**
 * 控件类型
 */
export enum DgControlType {

    /**
     * 按钮
     */
    Button = 'Button',
    /**
     * 按钮组
     */
    ButtonGroup = 'ButtonGroup',
    /**
     * 工具栏
     */
    ToolBar = 'ToolBar',

    ToolBarItem = 'ToolBarItem',
    /**
     * 容器
     */
    ContentContainer = 'ContentContainer',
    /**
     * 标签
     */
    DisplayField = 'DisplayField',
    /**
     * 输入框
     */
    TextBox = 'TextBox',

    /**
     * 多行输入框
     */
    MultiTextBox = 'MultiTextBox',
    /**
     * 帮助
     */
    LookupEdit = 'LookupEdit',
    /**
     * 数字
     */
    NumericBox = 'NumericBox',

    /**
     * 日期
     */
    DateBox = 'DateBox',

    /**
     * 开关
     */
    SwitchField = 'SwitchField',
    /**
     * 单选组
     */
    RadioGroup = 'RadioGroup',
    /**
     * 多选
     */
    CheckBox = 'CheckBox',
    /**
     * 多选框组
     */
    CheckGroup = 'CheckGroup',
    /**
     * 枚举（下拉框）
     */
    EnumField = 'EnumField',
    /**
     * 弹性布局
     */
    FlexLayout = 'FlexLayout',
    /**
     * 流布局
     */
    FlowLayout = 'FlowLayout',
    /**
     * 响应式布局
     */
    ResponseLayout = 'ResponseLayout',
    /**
     * 树表
     */
    TreeGrid = 'TreeGrid',
    /**
     * 树表列
     */
    TreeGridField = 'TreeGridField',
    /**
     * 分组
     */
    FieldSet = 'FieldSet',
    /**
     * Form组件
     */
    Form = 'Form',
    /**
     * 查询Form组件，用于搜索条件区域
     */
    QueryForm = 'QueryForm',
    /**
     * 表格
     */
    DataGrid = 'DataGrid',

    /**
     * 表格列
     */
    GridField = 'GridField',

    /**
     * 面板
     */
    Panel = 'Panel',
    /**
     * 模块
     */
    Module = 'Module',
    /**
     * 组件
     */
    Component = 'Component',
    /**
     * 图表
     */
    Charts = 'Charts',

    /**
     * 查询结果页框架
     */
    QdpFramework = 'QdpFramework',
    /**
     * spreadsheet
     */
    SpreadSheet = 'SpreadSheet',
    /**
     * qdpConditionDialog
     */
    QdpConditionDialog = 'QdpConditionDialog',

    /**
     * 外部引入组件容器
     */
    ExternalContainer = 'ExternalContainer',

    /**
     * 图片
     */
    Image = 'Image',

    /**
     * 隐藏区域
     */
    HiddenContainer = 'HiddenContainer',

    /**
     * 隐藏弹出区域
     */
    ModalContainer = 'ModalContainer',

    /**
     * 路由区域
     */
    RouteContainer = 'RouteContainer',

    /**
     * Tab标签
     */
    Tab = 'Tab',

    /**
     * 标签页
     */
    TabPage = 'TabPage',

    /**
     * 标签页工具栏按钮
     */
    TabToolbarItem = 'TabToolbarItem',

    /**
     * tag
     */
    Tag = 'Tag',

    /**
     * 侧边栏
     */
    Sidebar = 'Sidebar',

    /**
     * html模版容器
     */
    HtmlTemplate = 'HtmlTemplate',

    /**
     * ListView
     */
    ListView = 'ListView',

    /**
     * 富文本编辑器
     */
    RichTextBox = 'RichTextBox',

    /**
     * 时间调节器
     */
    TimeSpinner = 'TimeSpinner',

    /**
     * 时间选择器
     */
    TimePicker = 'TimePicker',

    /**
     * 区域
     */
    Section = 'Section',

    /**
     * 查询方案
     */
    QueryScheme = 'QueryScheme',

    /**
     * 表单标题区域
     */
    FormHeader = 'FormHeader',

    /**
     * Splitter
     */
    Splitter = 'Splitter',

    /**
     * SplitterPane
     */
    SplitterPane = 'SplitterPane',

    /**
     * 向导详情
     */
    WizardDetail = 'WizardDetail',

    /**
     * 向导详情组件容器
     */
    WizardDetailContainer = 'WizardDetailContainer',

    /**
     * 向导
     */
    Wizard = 'Wizard',

    /**
     * 数据分配组件（多选数据到右侧）
     */
    MultiSelect = 'MultiSelect',

    /**
     * 智能输入框
     */
    InputGroup = 'InputGroup',

    /**
     * 步骤条
     */
    Steps = 'Steps',

    /**
     * 头像
     */
    Avatar = 'Avatar',

    /**
     * 筛选条
     */
    ListFilter = 'ListFilter',

    /**
     * 列表导航
     */
    ListNav = 'ListNav',

    /**
     * 数字区间选择
     */
    NumberRange = 'NumberRange',

    /**
     * 滚动监听
     */
    Scrollspy = 'Scrollspy',

    /**
     * 多语控件
     */
    LanguageTextBox = 'LanguageTextBox',

    /**
     * 组件引用节点
     */
    ComponentRef = 'ComponentRef',

    /**
     * 附件上传
     */
    FileUpload = 'FileUpload',

    /**
     * 附件预览
     */
    FilePreview = 'FilePreview',

    // ******移动审批相关 begin**********************

    /**
     * 人员信息面板
     */
    DetailHeaderForMobileApprove = 'DetailHeaderForMobileApprove',

    /**
     * 详情面板
     */
    PanelForMobileApprove = 'PanelForMobileApprove',

    /**
     * 流程图面板
     */
    FlowProcessForMobileApprove = 'FlowProcessForMobileApprove',

    /**
     * 静态文本信息
     */
    StaticTextForMobileApprove = 'StaticTextForMobileApprove',

    // ****** 移动审批相关end*******************

    /**
     * 多视图切换
     */
    ViewChange = 'ViewChange',
    /**
     * 多视图容器
     */
    MultiViewContainer = 'MultiViewContainer',
    /**
     * 多视图 - 视图项
     */
    MultiViewItem = 'MultiViewItem',

    /**
     * 页脚
     */
    Footer = 'Footer',

    /**
     * 评论编辑区
     */
    DiscussionEditor = 'DiscussionEditor',

    /**
     * 评论列表
     */
    DiscussionList = 'DiscussionList',

    /**
     * 标签类型的导航
     */
    NavTab = 'NavTab',

    /**
     * 标签组
     */
    Tags = 'Tags',
    /**
     * 小部件
     */
    Portlet = 'Portlet'
}
